<template>
  <div class="estimate-container">
    <BlockHead />
    <BlockStats />
    <BlockHowItWorks />
    <BlockYouGot />
    <BlockDownloadDocumentation />
  </div>
</template>

<script>
import BlockHead from "./components/BlockHead"
import BlockStats from "./components/BlockStats"
import BlockHowItWorks from "./components/BlockHowItWorks"
import BlockYouGot from "./components/BlockYouGot"
import BlockDownloadDocumentation from "./components/BlockDownloadDocumentation"
export default {
  name: "",
  components: {
    BlockHead,
    BlockStats,
    BlockHowItWorks,
    BlockYouGot,
    BlockDownloadDocumentation,
  },
}
</script>

<style lang="scss" scoped>
@import "./src/front_white/sass/components/settings";
.estimate-container {
  max-width: $breakpoint-xxl;
  margin: auto;
}
</style>
